import { Logger } from '@saviynt/common';

import { httpService } from '../../../http-service/httpService';
import {
  CERT_DETAILS_VIEW_API_ERROR,
  CERT_DETAILS_VIEW_API_UNAUTHORIZED_ERROR,
  CERT_DETAILS_VIEW_LOADING,
  SET_PROGRESS_BREAKDOWN_DETAILS,
  SET_PROGRESS_BREAKDOWN_DETAILS_ERROR,
  SET_PROGRESS_BREAKDOWN_DETAILS_LOADING,
} from '../types';
import { URL_FETCH_PROGRESS_API, URL_VIEW_API } from '../urls';

export const getProgressBreakdownDetails =
  (certKey, groupByType, initialLoad) => async (dispatch, getState) => {
    const body = {
      certkey: certKey,
      group_by: groupByType,
    };

    const state = getState();
    const lineActions = state?.certifications?.details?.lineActions || {};
    const { reassignConfigMap = {} } = lineActions;
    const { isSecondaryCertifierLoggedIn } = reassignConfigMap;

    dispatch({ type: SET_PROGRESS_BREAKDOWN_DETAILS_LOADING, payload: true });

    try {
      const { data } = await httpService.post(URL_FETCH_PROGRESS_API, body);

      dispatch({
        type: SET_PROGRESS_BREAKDOWN_DETAILS,
        payload: { groupByType, data },
      });
    } catch (error) {
      // to handle 403 for secondary certifier after all lineitems reassigned to another user
      if (error === 403 && isSecondaryCertifierLoggedIn) {
        try {
          const { data } = await httpService.post(URL_VIEW_API, body);

          Logger.log('Cert details view api response', data);
        } catch (viewApiError) {
          if (viewApiError === 403) {
            if (isSecondaryCertifierLoggedIn) {
              window.location.replace('/ECMv6/certification/list');

              return;
            }

            dispatch({
              type: CERT_DETAILS_VIEW_API_UNAUTHORIZED_ERROR,
              payload: { isError: true },
            });
          } else {
            dispatch({
              type: CERT_DETAILS_VIEW_API_ERROR,
              payload: { isError: true },
            });
          }

          throw viewApiError;
        } finally {
          dispatch({ type: CERT_DETAILS_VIEW_LOADING, payload: false });
        }
      } else {
        dispatch({
          type: SET_PROGRESS_BREAKDOWN_DETAILS_ERROR,
          payload: { error: error.message, initialLoad },
        });
      }
    } finally {
      dispatch({
        type: SET_PROGRESS_BREAKDOWN_DETAILS_LOADING,
        payload: false,
      });
    }
  };

export default getProgressBreakdownDetails;
